exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li[data-v-59b0c90c]{color:#fff;margin:20px 20px 20px;font-size:18px;cursor:pointer}li[data-v-59b0c90c]:hover{background:#e5e5e5;color:#1a7fc5}", ""]);

// exports
